
import React from 'react'
import AziendaFrom from '../../rightSidebar/AziendaFrom'
import { Box } from '@mui/material'
import ProdottiForm from '../Prodotti/ProdottiForm'

export const ProdottiSlider = ({ cantine, setCantine }) => {

    return (
        <Box className='customDrawer_container'>
            <Box className='boxContainer__head'>
                <h2 className="boxContainer__title">Registra un Prodotto</h2>
            </Box>
            <ProdottiForm cantine={cantine} setCantine={setCantine} />
        </Box>
    )
}
